import * as React from "react";
import { DatasheetComponentTextStyle } from "@common/dto/datasheet/component-settings/text-style";

export type AddedTextValue = {
  fontFamily: string;
  fontSize: number;
  color: string;
  //TODO: Clarify styles model in BE integration.
  textStyle: Array<DatasheetComponentTextStyle>;
  text: string;
};

export type AddedTextProps = {
  value?: AddedTextValue;
  onChange: (value: AddedTextValue) => void;
};

export const useAddedTextController = (props: AddedTextProps) => {
  const { onChange } = props;

  const handleChange = React.useCallback((value: Partial<AddedTextValue>) => {
    if (props.value) {
      onChange({
        ...props.value,
        ...value,
      });
    }
  }, [onChange, props.value]);

  const handleFontFamilyChange = React.useCallback((fontFamily: string) => {
    handleChange({ fontFamily });
  }, [handleChange]);

  const handleFontSizeChange = React.useCallback((fontSize: number) => {
    handleChange({ fontSize });
  }, [handleChange]);

  const handleColorChange = React.useCallback((color: string) => {
    handleChange({ color });
  }, [handleChange]);

  const handleStylesChange = React.useCallback((textStyle: Array<DatasheetComponentTextStyle>) => {
    handleChange({ textStyle });
  }, [handleChange]);

  return {
    handleFontFamilyChange,
    handleFontSizeChange,
    handleColorChange,
    handleStylesChange,
  };
};